import { useEffect } from 'react';

import Layout from "../../hocs/layout/Layout";
import NavBar from "../../components/navigation/Navbar";
import Footer from "../../components/navigation/Footer";
import ContactForm from "../../components/contact/ContactForm";
import Header from "../../components/contact/Header"
import Mapa from "../../components/contact/Mapa";


function Contacto(){
    useEffect(() => {
            window.scrollTo(0,0)
        },[])
    return(
        <Layout>
            <NavBar/>
            <div>
                <Header/>
                <ContactForm/>
                <Mapa/>
            </div>
            <Footer/>
        </Layout>
    )
}export default Contacto;